import { ReactElement } from 'react';
import { useOutletContext } from 'react-router-dom';
import Plotter from '../../../components/Plotter';

interface RunPlotterContext {
  run?: any;
  isRunsPending: boolean;
  isRunsFetching: boolean;
  calibration?: any;
}

export default function RunPlotter(): ReactElement {
  const { run, isRunsPending, calibration } = useOutletContext<RunPlotterContext>();

  const availableFields = [
    { label: 'Body Position Head', field: 'BodyPosHead_sG21_cm' },
    { label: 'Body Position Chest', field: 'BodyPosChest_sG21_cm' },
    { label: 'Body Position Waist', field: 'BodyPosWaist_sG21_cm' },
    { label: 'Body Position Head Delta', field: 'BodyPosHeadDelta_sG21_cm' },
    { label: 'Body Position Chest Delta', field: 'BodyPosChestDelta_sG21_cm' },
    { label: 'Body Position Waist Delta', field: 'BodyPosWaistDelta_sG21_cm' },
    { label: 'Body Position Head Reference', field: 'BodyPosRefHead_sG11_cm' },
    { label: 'Body Position Chest Reference', field: 'BodyPosRefChest_sG11_cm' },
    { label: 'Body Position Waist Reference', field: 'BodyPosRefWaist_sG11_cm' },
  ];

  // Example for a second plotter (customize as needed)
  const speedFields = [
    { label: 'Road Speed', field: 'RoadSpeed' },
    { label: 'Air Speed', field: 'AirSpeed' },
  ];

  const speedFieldsSecondary = [{ label: 'Rider Power', field: 'RiderPwr_P' }];

  return (
    <div className="cr-flex cr-flex-col cr-gap-4">
      <Plotter
        isPending={isRunsPending}
        availableFields={speedFields}
        data={run?.data_gridded || null}
        title="Road and Air Speed vs Time"
        storageKey="run-plotter-speed-selections"
        yAxisTitle="Speed (km/h)"
        yAxisUnit="km/h"
        availableFieldsSecondary={speedFieldsSecondary}
        yAxisTitleRight="Power (W)"
        yAxisUnitRight="W"
        calibration={calibration}
        segmentTimestamps={run?.segment_ts}
        excludeCandidates={run?.exclude_candidates_ts}
        excludeTs={run?.exclude_ts}
        runId={run?.id}
      />
      <Plotter
        isPending={isRunsPending}
        availableFields={availableFields}
        data={run?.data_gridded || null}
        title="Body Position vs Time"
        storageKey="run-plotter-bodypos-selections"
        yAxisTitle="Body Position (cm)"
        yAxisUnit="cm"
      />
    </div>
  );
}
